import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64", ...t }, /* @__PURE__ */ e.createElement("path", { d: "m25.877 16-3.76 3.76L34.331 32 22.117 44.24l3.76 3.76 16-16z" }));
export {
  a as default
};
